import React from 'react';
import {
	ISection,
	MERGED_QUICK_LINK_SECTIONS_TYPE_ID,
} from '../../content-sections/domain/models';
import {
	renderSectionComponent,
	SectionErrorBoundary,
} from '../../content-sections/ui';
import { NEWS_SECTION_TYPE_ID } from '../../shared/api/contentful/constants';
import { getListedEntryKey } from '../../shared/utils/getListedEntryKey';
import { NewsSection } from '../ui/components/NewsSection';

export const renderCustomExternalNewsCard = (
	section: ISection,
	index: number,
) => {
	const key =
		section.contentType === MERGED_QUICK_LINK_SECTIONS_TYPE_ID
			? section.id
			: getListedEntryKey(section, index);

	return (
		<SectionErrorBoundary
			key={key}
			entryId={section.id}
			contentType={section.contentType}
		>
			{section.contentType === NEWS_SECTION_TYPE_ID ? (
				<NewsSection section={section} maxItems={4} />
			) : (
				renderSectionComponent(section)
			)}
		</SectionErrorBoundary>
	);
};
